module.exports = __webpack_public_path__ + "static/media/2ab1038f-3bd7-4171-a9c1-8c08a946f812_1.692b4ce586699ac230f5f0762de8317a.9b38d52e.jpeg";